import styled from '@emotion/styled';
import React, { useEffect, useRef, useState, Suspense } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CustomPopup from '../../common/CustomPopup';
import { Button, Divider, Heading, Icon, ActionIcon, Text } from '../../common';
import { InputText, TextArea } from '../../components/form';
import { CustomButton } from '../../common/commonStyled';
import DesignQuestion from './DesignQuestion';
import maverickPortalhttp from '../../utils/webService/webService';
import maverickPortalApiEndPoint from '../../config/apiEndPoint';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { CSS } from '@dnd-kit/utilities';
import {
  closestCenter,
  defaultDropAnimationSideEffects,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  MeasuringStrategy,
  MouseSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import {
  arrayMove,
  defaultAnimateLayoutChanges,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable
} from '@dnd-kit/sortable';
import { PiDotsSixVerticalBold } from 'react-icons/pi';
import './DeleteQuestionToast.css';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import PageLoader from '../PageLoader';
import SectionDetailsEditor from './components/SectionDetailsEditor';

const CustomButtont = styled(Button)`
  padding: 2px 1rem;
  color: var(--white);
  buttoncolor: var(--sapGreen);
  cursor: pointer;
`;

const CustomDivider = () => <Divider width="100%" height="1px" margin="1.5rem 0" background="var(--greyBlue)" />;
const VIRTUAL_KEYBOARD_STORAGE_KEY = 'design.interview.useVirtualKeyboard';

const toShuffleSectionFlag = value => (Number(value) === 1 ? 1 : 0);

const buildShuffleSectionEditPayload = ({ userId, section, shuffleQuestion }) => {
  const formData = new FormData();
  formData.append('user_ID', userId);
  formData.append('QuestionPaperSection_ID', section.questionPaperSection_ID);
  formData.append('sectionName', section.sectionName || '');
  formData.append('sectionDescription', section.sectionDescription || '');
  formData.append('timer', section.timer || '');
  formData.append('shuffleQuestion', shuffleQuestion);
  formData.append('sectionImage', section.presignedUrlSectionImage || section.sectionImage || '');
  formData.append('fileType', section.fileType ?? '');
  return formData;
};

function isInteractiveElement(element) {
  const interactiveElements = ['button', 'input', 'textarea', 'select', 'option'];
  return element?.tagName && interactiveElements.includes(element.tagName.toLowerCase());
}

class SmartPointerSensor extends PointerSensor {
  static activators = [
    {
      eventName: 'onPointerDown',
      handler: ({ nativeEvent: event }) => {
        if (!event.isPrimary || event.button !== 0 || isInteractiveElement(event.target)) {
          return false;
        }
        return true;
      }
    }
  ];
}

export default function DesignInterviewTab({
  task,
  nextTask,
  videoTaskList,
  questionTypeList,
  screenerTypeOption,
  masterTags,
  handleTaskTab,
  ValueTypeChoices,
  addQuestionDisable,
  setAddQuestionDisable,
  questionIndex,
  isTaskDescriptionEditing,
  onTaskDescriptionEdit,
  onSaveTaskDescription
}) {
  const loggedUser = useSelector(state => state.LoginReducer);
  const [message, setMessage] = useState(false);
  const projectTask_ID = task.projectTask_ID;
  const { projectId } = useParams();
  const [index, setIndex] = useState(null);
  const [popup, setPopup] = useState(false);
  const [interviewTask, setInterviewTask] = useState(task);
  const [interviewTaskSections, setInterviewTaskSections] = useState(videoTaskList);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [editSectionIndex, seteditSectionIndex] = useState(null);
  const [sectionNameError, setSectionNameError] = useState(false);
  const [sectionSavedStatus, setSectionSavedStatus] = useState([]);
  const [editQuestionIndex, setEditQuestionIndex] = useState(null);
  const dispatch = useDispatch();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isPopup, setIsPopup] = useState(false);
  //const [popupMessage, setPopupMessage] = useState('');
  const [popupColor, setPopupColor] = useState('');
  const addSec = useSelector(state => state.ProjectReducer?.addSection);
  const editSec = useSelector(state => state.ProjectReducer?.editSection);
  const editQues = useSelector(state => state.TaskReducer?.editQuestion);
  const addQues = useSelector(state => state.TaskReducer?.addQuestion);
  const deleteSec = useSelector(state => state.ProjectReducer?.deleteSec);
  const deleteQues = useSelector(state => state.TaskReducer?.deleteQues);
  const dragQuestion = useSelector(state => state.ProjectReducer?.dragQuestion);
  const dragSection = useSelector(state => state.ProjectReducer?.dragSection);
  const dragQuestionAcrossSections = useSelector(state => state.ProjectReducer?.dragQuestionAcrossSections);
  const initialLoad = useRef(true);
  const sectionShuffleRef = useRef({});

  const [sectionmessage, setsectionMessage] = useState(null);
  const [newQuestionIndex, setNewQuestionIndex] = useState(null);
  const [questionmessage, setquestionMessage] = useState(null);
  const [QuestionIndex, setQuestionIndex] = useState(null);
  const [switchvalue, setSwitchValue] = useState(0);
  const [isNewSection, setisNewSection] = useState(false);
  const [addSectionDisable, setAddSectionDisbale] = useState(false);
  const [isSectionSaveLoading, setIsSectionSaveLoading] = useState(false);
  const [editQuestionId, setEditQuestionId] = useState('');
  const [isAddingNewSection, setIsAddingNewSection] = useState(false);
  const [deletesectionmessage, setdeletesectionMessage] = useState(null);
  const [deleteSectionIndex, setDeleteSectionIndex] = useState(null);
  const [deleteQuestionIndex, setDeleteQuestionIndex] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isVirtualKeyboardEnabled, setIsVirtualKeyboardEnabled] = useState(() => {
    const saved = localStorage.getItem(VIRTUAL_KEYBOARD_STORAGE_KEY);
    return saved === 'true';
  });

  // Show a loader until videoTaskList data is available from the parent
  const shouldShowInitialLoader = !videoTaskList || videoTaskList.length === 0;

  const handleSetEditing = () => {
    setIsEditing(false);
  };

  useEffect(() => {
    localStorage.setItem(VIRTUAL_KEYBOARD_STORAGE_KEY, String(isVirtualKeyboardEnabled));
  }, [isVirtualKeyboardEnabled]);

  // Keep all accordions closed by default
  const [openSections, setOpenSections] = useState(new Set());

  const [draggingItem, setDraggingItem] = useState(null);
  const dragSourceSectionId = useRef(null);

  const toggleOpen = (sectionId, preventScroll = false) => {
    setOpenSections(prev => {
      const newSet = new Set(prev);
      if (newSet.has(sectionId)) {
        newSet.delete(sectionId);
      } else {
        newSet.add(sectionId);
        if (!preventScroll) {
          setTimeout(() => {
            const sectionEl = document.querySelector(`[data-section-id="${sectionId}"]`);
            if (sectionEl) {
              sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
      }
      return newSet;
    });
  };

  useEffect(() => {
    if (newQuestionIndex !== null) {
      const section = interviewTaskSections[newQuestionIndex];
      const sectionId = section?.questionPaperSection_ID;
      if (sectionId && openSections.has(sectionId)) {
        const sectionEl = document.querySelector(`[data-section-id="${sectionId}"]`);
        if (sectionEl) {
          const lists = sectionEl.querySelectorAll('.questions-list');
          const inner = lists[lists.length - 1];
          if (inner) {
            const target = inner.lastElementChild || inner;
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            sectionEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
    }
  }, [newQuestionIndex, openSections, interviewTaskSections]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8
      }
    }),
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 8
      }
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5
      }
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );

  const isSectionBeingDragged = activeId => {
    return interviewTaskSections.some(s => s.questionPaperSection_ID === activeId);
  };

  let questionTypes = questionTypeList?.map(questionType => {
    return questionType.questionType_ID == 9 ||
      questionType.questionType_ID == 10 ||
      questionType.questionType_ID == 11 ||
      questionType.questionType_ID == 4 ||
      questionType.questionType_ID == 1 ||
      questionType.questionType_ID == 5 ||
      questionType.questionType_ID == 6 ||
      questionType.questionType_ID == 2 ||
      questionType.questionType_ID == 7 ||
      questionType.questionType_ID == 14
      ? { ...questionType, label: questionType.questionTypeName, value: questionType.questionType_ID }
      : null;
  });

  questionTypes = questionTypes?.filter(function(questionType) {
    return questionType != null;
  });
  useEffect(() => {
    if (!addSec?.StatusCode && !editSec?.StatusCode) {
      return;
    }

    if (addSec?.StatusCode == 1) {
      setPopupColor('var(--sapGreen)');
      setsectionMessage('Section Added Successfully!');
    }
    if (addSec?.StatusCode == -1) {
      setPopupColor('red');
      setsectionMessage('Error While Adding Section');
      setIsSectionSaveLoading(false);
      setAddQuestionDisable(false);
    }
    maverickPortalhttp
        .makeRequest(
          `${maverickPortalApiEndPoint.getVideoTask.url}/${loggedUser.userId}/${projectId}/${projectTask_ID}`,
          maverickPortalApiEndPoint.getVideoTask.methodType
        )
      .then(response => {
        let videoTaskData = response.data.Response;
        const newSections = videoTaskData?.GetProjectTaskQuestions;
        setInterviewTaskSections(newSections);
        setIsSectionSaveLoading(false);
        setAddQuestionDisable(false);
        // Do not auto-open accordions; they stay closed by default
      })
      .catch(() => {
        setIsSectionSaveLoading(false);
        setAddQuestionDisable(false);
      });

    const timeout = setTimeout(() => {
      setsectionMessage(null);
      seteditSectionIndex(null);
      dispatch({ type: 'CLEAR_ADD_SECTION' });
      dispatch({ type: 'CLEAR_EDIT_SECTION' });
    }, 3000);
  }, [addSec, editSec]);

  //Rutujas code for add question message
  useEffect(() => {
    if (addQues !== undefined) {
      if (addQues?.StatusCode == 1) {
        setIsPopup(true);
        setPopupColor('var(--sapGreen)');
        setquestionMessage('Question Added Successfully!');
      }
      if (addQues?.StatusCode == -1) {
        setIsPopup(true);
        setPopupColor('red');
        setquestionMessage('Error While Adding Question');
      }
      maverickPortalhttp
        .makeRequest(
          `${maverickPortalApiEndPoint.getVideoTask.url}/${loggedUser.userId}/${projectId}/${projectTask_ID}`,
          maverickPortalApiEndPoint.getVideoTask.methodType
        )
        .then(response => {
          let videoTaskData = response.data.Response;
          setInterviewTaskSections(videoTaskData?.GetProjectTaskQuestions);
        });

      const timeout = setTimeout(() => {
        setIsPopup(false);
        setquestionMessage(null);
        setNewQuestionIndex(null);
        dispatch({ type: 'CLEAR_ADD_QUESTION' });
      }, 3000);
    }
  }, [addQues]);

  useEffect(() => {
    if (editSec?.StatusCode == 1) {
      setPopupColor('var(--sapGreen)');
      setsectionMessage('Section Edited Successfully!');
    }
    if (editSec?.StatusCode == -1) {
      setPopupColor('red');
      setsectionMessage('Error While Editing The Section');
    }

    const timeout = setTimeout(() => {
      setsectionMessage(null);
      seteditSectionIndex(null);
      dispatch({ type: 'CLEAR_EDIT_SECTION' });
    }, 3000);
  }, [editSec]);

  useEffect(() => {
    if (editQues !== undefined) {
      if (editQues?.StatusCode == 1) {
        setPopupColor('var(--sapGreen)');
        // setquestionMessage('Question Edited Successfully!');
        setquestionMessage(editQues?.StatusDesc);
      }
      if (editQues?.StatusCode == -1) {
        setPopupColor('red');
        // setquestionMessage('Question response is already saved. You can not Edit question.');
        setquestionMessage(editQues?.StatusDesc);
      }
      maverickPortalhttp
        .makeRequest(
          `${maverickPortalApiEndPoint.getVideoTask.url}/${loggedUser.userId}/${projectId}/${projectTask_ID}`,
          maverickPortalApiEndPoint.getVideoTask.methodType
        )
        .then(response => {
          let videoTaskData = response.data.Response;
          setInterviewTaskSections(videoTaskData?.GetProjectTaskQuestions);
        });
      const timeout = setTimeout(() => {
        setquestionMessage(null);
        setEditQuestionId('');
        dispatch({ type: 'CLEAR_EDIT_QUESTION' });
      }, 3000);
    }
  }, [editQues]);

  const toastDisplayed = useRef(false);

  useEffect(() => {
    if (initialLoad.current) {
      initialLoad.current = false;
      return;
    }

    if (deleteSec?.StatusCode && !toastDisplayed.current) {
      const message = deleteSec?.StatusDesc;

      if (deleteSec?.StatusCode === '-1') {
        toast.error(<>{message}</>, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          transition: Bounce
        });
        setIsPopup(true);
      } else if (deleteSec?.StatusCode === '1') {
        toast.success(
          <div style={{ display: 'flex', alignItems: 'center', padding: '8px 0' }}>
            <FontAwesomeIcon
              icon={faCircleCheck}
              style={{ color: 'var(--primaryColor)', marginRight: '8px', fontSize: '1.5em' }}
            />
            <span>{message}</span>
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
            icon: false,
            transition: Bounce
          }
        );
        setIsPopup(true);
      }

      toastDisplayed.current = true;

      setTimeout(() => {
        setIsPopup(false);
        dispatch({ type: 'CLEAR_DELETE_SECTION' });
        toastDisplayed.current = false;
      }, 4500);

      maverickPortalhttp
        .makeRequest(
          `${maverickPortalApiEndPoint.getVideoTask.url}/${loggedUser.userId}/${projectId}/${projectTask_ID}`,
          maverickPortalApiEndPoint.getVideoTask.methodType
        )
        .then(response => {
          let videoTaskData = response.data.Response;
          setInterviewTaskSections(videoTaskData?.GetProjectTaskQuestions);
        });
    }
  }, [deleteSec]);

  useEffect(() => {
    if (initialLoad.current) {
      initialLoad.current = false;
      return;
    }

    if (deleteQues?.StatusCode && !toastDisplayed.current) {
      const message = deleteQues?.StatusDesc;

      if (deleteQues?.StatusCode === '-1') {
        toast.error(<>{message}</>, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          transition: Bounce
        });
        setIsPopup(true);
      } else if (deleteQues?.StatusCode === '1') {
        toast.success(
          <div style={{ display: 'flex', alignItems: 'center', padding: '8px 0' }}>
            <FontAwesomeIcon
              icon={faCircleCheck}
              style={{ color: 'var(--primaryColor)', marginRight: '8px', fontSize: '1.5em' }}
            />
            <span>{message}</span>
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
            icon: false,
            transition: Bounce
          }
        );
        setIsPopup(true);
      }

      toastDisplayed.current = true;

      setTimeout(() => {
        setIsPopup(false);
        dispatch({ type: 'CLEAR_DELETE_QUESTION' });
        toastDisplayed.current = false;
      }, 4500);

      maverickPortalhttp
        .makeRequest(
          `${maverickPortalApiEndPoint.getVideoTask.url}/${loggedUser.userId}/${projectId}/${projectTask_ID}`,
          maverickPortalApiEndPoint.getVideoTask.methodType
        )
        .then(response => {
          let videoTaskData = response.data.Response;
          setInterviewTaskSections(videoTaskData?.GetProjectTaskQuestions);
        });
      const timeout = setTimeout(() => {
        setIsPopup(false);
        setquestionMessage(null);
        dispatch({ type: 'CLEAR_DELETE_QUESTION' });
        // getCriteriaBudgetQuestion();
      }, 3000);
    }
  }, [deleteQues]);

  useEffect(() => {
    if (!dragQuestion && !dragSection && !dragQuestionAcrossSections) {
      return;
    }

    refreshTask();
  }, [dragQuestion, dragSection, dragQuestionAcrossSections]);

  useEffect(() => {
    (videoTaskList || []).forEach(section => {
      const sectionId = section?.questionPaperSection_ID;
      if (
        sectionId != null &&
        section?.shuffleQuestion !== undefined &&
        section?.shuffleQuestion !== null &&
        section?.shuffleQuestion !== ''
      ) {
        sectionShuffleRef.current[sectionId] = toShuffleSectionFlag(section.shuffleQuestion);
      }
    });
    setInterviewTaskSections(videoTaskList);
    // Keep existing open/closed state; do not force-open all accordions
  }, [videoTaskList]);

  const getSectionShuffleValue = section => {
    if (section?.shuffleQuestion !== undefined && section?.shuffleQuestion !== null && section?.shuffleQuestion !== '') {
      return toShuffleSectionFlag(section.shuffleQuestion);
    }
    const sectionId = section?.questionPaperSection_ID;
    if (sectionId != null && sectionShuffleRef.current[sectionId] != null) {
      return sectionShuffleRef.current[sectionId];
    }
    return (section?.questionName_array || []).some(question => Number(question?.shuffleQuestion) === 1) ? 1 : 0;
  };

  // Interview: do not disable Shuffle Questions for isLogicApplied
  const applySectionShuffle = (sections, sectionId, shuffleQuestion) =>
    sections.map(item =>
      item.questionPaperSection_ID === sectionId
        ? {
            ...item,
            shuffleQuestion,
            questionName_array: (item.questionName_array || []).map(question => ({
              ...question,
              shuffleQuestion
            }))
          }
        : item
    );

  const handleShuffleSectionToggle = (sIndex, checked) => {
    const section = interviewTaskSections[sIndex];
    if (
      section?.isNew ||
      !section?.questionPaperSection_ID ||
      (section?.questionName_array || []).length < 2
    ) {
      return;
    }

    const shuffleQuestion = checked ? 1 : 0;
    const sectionId = section.questionPaperSection_ID;

    sectionShuffleRef.current[sectionId] = shuffleQuestion;
    setInterviewTaskSections(prev => applySectionShuffle(prev, sectionId, shuffleQuestion));

    dispatch({
      type: 'EDIT_SECTION',
      payload: buildShuffleSectionEditPayload({
        userId: loggedUser.userId,
        section,
        shuffleQuestion
      })
    });
  };


  useEffect(() => {
    setTimeout(() => {
      setisNewSection(false);
    }, 3000);
  }, [isNewSection]);

  const dropAnimation = {
    sideEffects: defaultDropAnimationSideEffects({
      styles: {
        active: {
          opacity: '0.5'
        }
      }
    })
  };

  const animateLayoutChanges = args => defaultAnimateLayoutChanges({ ...args, wasDragging: true });

  const SortableSection = React.memo(({ section, isOpen, toggleOpen, isDragging, sIndex }) => {
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition } = useSortable({
      id: section.questionPaperSection_ID
    });

    const style = {
      transform: CSS.Translate.toString(transform),
      transition,
      border: isDragging ? '4px solid #83A600' : ''
    };
    const [editSaveButton, setEditSaveButton] = useState(false);

    return (
      <div ref={setNodeRef} style={style} data-section-id={section.questionPaperSection_ID}>
        {/* Child Questions (Do Not Trigger Toggle) */}
        <React.Fragment key={section.questionPaperSection_ID}>
          <CustomDivider />
          <div className="row">
            <div className="col-12">
              {isPopupVisible && deletesectionmessage && sIndex === 0 && (
                <center>
                  <div style={{ color: popupColor, fontWeight: 'bold', textAlign: 'left' }}>
                    <div>{deletesectionmessage}</div>
                  </div>
                </center>
              )}
              <div className="d-flex flex-column align-items-center" style={{ float: 'right' }}>
                <CustomButton
                  variant="outlined"
                  buttonColor="var(--greyBlue)"
                  className=""
                  //onClick={(e) => handleDeleteSection(sIndex)}
                  onClick={e => {
                    setPopup(!popup), setIndex(sIndex);
                  }}
                  style={{
                    color: 'var(--greyBlue)',
                    backgroundColor: 'white',
                    fontSize: '15px'
                  }}
                >
                  <Icon className="material-icons-round" style={{ color: 'var(--greyBlue)', marginTop: '1.5px' }}>
                    delete
                  </Icon>
                  Delete Section
                </CustomButton>
                <CustomPopup
                  onClose={closeHandler}
                  showed={popup}
                  heading="Confirm delete"
                  secondheading="Are you sure you want to delete this Section?"
                  secondheading2="Once deleted, it cant be retrieved."
                >
                  <CustomButtont
                    fontSize="14px"
                    fontWeight="300"
                    color="black"
                    size="medium"
                    style={{ justifyContent: 'space-between', marginRight: '20px' }}
                    onClick={() => {
                      handleDeleteSection(index);
                    }}
                  >
                    Delete
                  </CustomButtont>
                </CustomPopup>
                {!section.isNew &&
                  section.questionPaperSection_ID &&
                  (section.questionName_array || []).length >= 2 && (
                    <div
                      className="d-flex align-items-end justify-content-center"
                      style={{
                        marginTop: '8px',
                        width: '100%',
                        cursor: 'pointer'
                      }}
                      onClick={e => e.stopPropagation()}
                      onPointerDown={e => e.stopPropagation()}
                    >
                      <label
                        className="switch"
                        style={{
                          marginLeft: 0,
                          marginRight: 0,
                          marginTop: 0,
                          marginBottom: 0,
                          cursor: 'pointer'
                        }}
                      >
                        <input
                          type="checkbox"
                          name={`shuffleQuestion-${section.questionPaperSection_ID || sIndex}`}
                          checked={getSectionShuffleValue(section) === 1}
                          onChange={e => handleShuffleSectionToggle(sIndex, e.target.checked)}
                        />
                        <span className="slider round" style={{ cursor: 'pointer' }}></span>
                      </label>
                      <span
                        style={{
                          color: 'var(--greyBlue)',
                          fontSize: '0.8125rem',
                          fontWeight: 500,
                          marginLeft: '8px',
                          lineHeight: 1,
                          whiteSpace: 'nowrap',
                          paddingBottom: '1px',
                          cursor: 'pointer'
                        }}
                      >
                        Shuffle Questions
                      </span>
                    </div>
                  )}
              </div>
              <div className="section-wrapper ">
                <div className="row g-3 align-items-start" style={{ cursor: 'pointer' }}>
                  <div className="col-auto flex-shrink-0">
                    <div className="d-flex">
                      <button
                        ref={setActivatorNodeRef}
                        {...listeners}
                        {...attributes}
                        style={{
                          cursor: 'grab',
                          padding: 0,
                          margin: 0,
                          border: 0
                        }}
                      >
                        <PiDotsSixVerticalBold />
                      </button>
                      <Heading
                        type="5"
                        className="mt-2"
                        color="var(--seaBlue)"
                        onClick={() => toggleOpen(section.questionPaperSection_ID)}
                      >
                        Section {+sIndex + +1}
                        {isOpen ? '▼' : '▶'}
                      </Heading>
                    </div>
                  </div>
                  {interviewTaskSections[sIndex].sectionName == '' &&
                  interviewTaskSections[sIndex].sectionDescription == '' ? (
                    <div className="col" style={{ minWidth: 0 }}>
                      <SectionDetailsEditor
                        sectionKey={section.questionPaperSection_ID || sIndex}
                        sectionName={section.sectionName}
                        sectionDescription={section.sectionDescription}
                        isVirtualKeyboardEnabled={isVirtualKeyboardEnabled}
                        namePlaceholder="Add a section name"
                        descriptionPlaceholder="Add section description"
                        nameWidth="100%"
                        onSectionFieldChange={(field, value) => {
                          const tempInterviewTaskSections = interviewTaskSections;
                          if (tempInterviewTaskSections[sIndex]) {
                            tempInterviewTaskSections[sIndex][field] = value;
                          }
                        }}
                        onSectionEdit={() => setShowSaveButton(true)}
                      />
                      {sectionNameError && (
                        <p style={{ color: 'red', fontSize: '11px' }}>Please fill in the section name.</p>
                      )}

                      {showSaveButton && (
                        // code for section button and popup
                        <>
                          <CustomButton
                            variant="outlined"
                            buttonColor="var(--sapGreen)"
                            className="mt-3"
                            data-virtualkeyboard-ignore="true"
                            onClick={e => {
                              e.stopPropagation();
                              if (!section.sectionName.trim()) {
                                setSectionNameError(true);
                              } else {
                                setSectionNameError(false);
                                storeSection(sIndex, 'sectionDescription', e.target.value);
                                setisNewSection(true);
                                setAddSectionDisbale(false);
                                setShowSaveButton(false);
                              }
                            }}
                          >
                            <Icon>save</Icon>
                            Save Section
                          </CustomButton>
                        </>
                      )}
                    </div>
                  ) : (
                    <div className="col" style={{ minWidth: 0 }}>
                      <SectionDetailsEditor
                        sectionKey={section.questionPaperSection_ID || sIndex}
                        sectionName={section.sectionName}
                        sectionDescription={section.sectionDescription}
                        isVirtualKeyboardEnabled={isVirtualKeyboardEnabled}
                        namePlaceholder="Add a section name"
                        descriptionPlaceholder="Add section description"
                        nameWidth="100%"
                        onSectionFieldChange={(field, value) => {
                          const tempInterviewTaskSections = interviewTaskSections;
                          if (tempInterviewTaskSections[sIndex]) {
                            tempInterviewTaskSections[sIndex][field] = value;
                          }
                        }}
                        onSectionEdit={() => setEditSaveButton(true)}
                      />
                      {editSectionIndex === section.questionPaperSection_ID && sectionNameError && (
                        <p style={{ color: 'red', fontSize: '11px' }}>Please fill in the section name.</p>
                      )}
                      {(editSectionIndex === section.questionPaperSection_ID|| editSaveButton) && (
                        <>
                          <CustomButton
                            variant="outlined"
                            buttonColor="var(--sapGreen)"
                            className="mt-3"
                            data-virtualkeyboard-ignore="true"
                            onClick={e => {
                              e.stopPropagation();

                              if (!section.sectionName.trim()) {
                                setSectionNameError(true);
                              } else {
                                setSectionNameError(false);
                                updateSection(sIndex, 'sectionName', section.sectionName);
                                updateSection(sIndex, 'sectionDescription', section.sectionDescription);
                                setShowSaveButton(false);
                                setEditSaveButton(false);

                              }
                            }}
                          >
                            <Icon>save</Icon>
                            Save Section
                          </CustomButton>
                        </>
                      )}
                    </div>
                  )}
                  {editSectionIndex === section.questionPaperSection_ID && sectionmessage && (
                    <center>
                      <div style={{ color: popupColor, fontWeight: 'bold', textAlign: 'left' }}>
                        <div>{sectionmessage}</div>
                      </div>
                    </center>
                  )}
                </div>
                {isOpen && !isDragging && (
                  <>
                    <div
                      className="questions-list mt-3"
                      // style={{ borderLeft: '3px solid var(--greyBlue) !important' }}
                    >
                      <SortableContext
                        items={section.questionName_array.map(q => q.question_ID).filter(id => id !== null)}
                      >
                        <React.Fragment key={section.questionPaperSection_ID}>
                          <div className="questions-list mt-3">
                            {section?.questionName_array?.map((question, qIndex) => (
                              <SortableQuestion
                                key={question.question_ID}
                                question={question}
                                qIndex={qIndex}
                                section={section}
                                sIndex={sIndex}
                              />
                            ))}
                          </div>
                        </React.Fragment>
                      </SortableContext>
                    </div>

                    {newQuestionIndex == sIndex && questionmessage && (
                      <center>
                        <div style={{ color: popupColor, fontWeight: 'bold', textAlign: 'left' }}>
                          <div>{questionmessage}</div>
                        </div>
                      </center>
                    )}

                    {isPopupVisible && deletesectionmessage && deleteSectionIndex == index + 1 && (
                      <center>
                        <div style={{ color: popupColor, fontWeight: 'bold', textAlign: 'left' }}>
                          <div>{deletesectionmessage}</div>
                        </div>
                      </center>
                    )}
                  </>
                )}
                <CustomButton
                  variant="outlined"
                  buttonColor="var(--sapGreen)"
                  className="mt-5"
                  onClick={e => createQuestion(sIndex)}
                  disabled={section.isNew || addQuestionDisable || isSectionSaveLoading}
                >
                  <Icon>add</Icon>
                  Add Question
                </CustomButton>
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    );
  });

  const SortableQuestion = React.memo(({ question, qIndex, section, sIndex }) => {
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
      id: question.question_ID,
      animateLayoutChanges,
      transition: {
        duration: 200,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
      }
    });

    const questioncount = section?.questionName_array?.length ?? 1;
    const stackz = 10 + Math.max(0, questioncount - 1 - qIndex);

    const style = {
      transform: CSS.Translate.toString(transform),
      transition: isDragging ? 'transform 0.2s ease' : transition,
      background: 'white',
      position: 'relative',
      zIndex: isDragging ? 1000 : stackz,
      opacity: isDragging ? 0 : 1,
      cursor: isDragging ? 'grabbing' : 'default',
      transformOrigin: 'center center',
      willChange: 'transform, opacity'
    };

    return (
      <>
        <div ref={setNodeRef} style={style}>
          <div
            key={question.question_ID}
            index={qIndex}
            onPointerDown={e => {
              // While editing, don't interfere with pointer events so inputs/buttons work normally
              if (isEditing) return;
              e.stopPropagation();
              e.preventDefault();
            }}
            style={{
              position: 'relative',
              transform: isDragging ? 'scale(1.02)' : 'scale(1)',
              transition: 'transform 0.2s ease'
            }}
          >
            <button
              ref={setActivatorNodeRef}
              {...(!isEditing ? { ...listeners, ...attributes } : {})}
              style={{
                cursor: isEditing ? 'default' : isDragging ? 'grabbing' : 'grab',
                padding: 0,
                margin: 0,
                border: 0,
                position: 'absolute',
                zIndex: 100,
                top: '50%',
                transform: 'translateY(-50%)',
                opacity: isEditing ? 0 : isDragging ? 0 : 0.7,
                transition: 'opacity 0.2s ease',
                backgroundColor: 'transparent',
                pointerEvents: isEditing ? 'none' : 'auto'
              }}
            >
              <PiDotsSixVerticalBold />
            </button>
            <DesignQuestion
              key={qIndex}
              sectionIndex={sIndex}
              questionIndex={qIndex}
              questionArrayLength={section?.questionName_array?.length}
              setSwitchValue={setSwitchValue}
              switchvalue={switchvalue}
              sectionId={section.questionPaperSection_ID}
              question={question}
              questionTypes={questionTypes}
              screenerTypeOption={screenerTypeOption}
              ValueTypeChoices={ValueTypeChoices}
              masterTags={masterTags}
              enableEdit={editQuestionId == question?.question_ID}
              setEditQuestionId={setEditQuestionId}
              handleChangeQuestionType={handleChangeQuestionType}
              handleDuplicateQuestion={handleDuplicateQuestion}
              handleDeleteQuestion={handleDeleteQuestion}
              handleProjectTaskTab={handleProjectTaskTab}
              refreshTask={refreshTask}
              isInterview={task.taskType !== 'Form'}
              setEditQuestionIndex={setEditQuestionIndex}
              setNewQuestionIndex={setNewQuestionIndex}
              setDeleteQuestionIndex={setDeleteQuestionIndex}
              setQuestionIndex={setQuestionIndex}
              setAddQuestionDisable={setAddQuestionDisable}
              questionmessage={questionmessage}
              popupColor={popupColor}
              showCheckbox={true}
              handleEditQuestion={handleEditQuestion}
              handleSetEditing={handleSetEditing}
              setInterviewTaskSections={setInterviewTaskSections}
              interviewTaskSections={interviewTaskSections}
              task={task}
              isVirtualKeyboardEnabled={isVirtualKeyboardEnabled}
            />
          </div>
        </div>
      </>
    );
  });

  const createSection = () => {
    setIsAddingNewSection(true);
    let tempInterviewTaskSections = interviewTaskSections;
    tempInterviewTaskSections = [
      ...tempInterviewTaskSections,
      { sectionName: '', sectionDescription: '', questionName_array: [], isNew: true }
    ];

    setInterviewTaskSections(tempInterviewTaskSections);
    setShowSaveButton(true);
    setAddSectionDisbale(true);
    setSectionNameError(false);
    setSectionSavedStatus(prevStatus => [...prevStatus, false]);
  };

  const handleDragStart = event => {
    const { active } = event;
    setDraggingItem(active.id);

    const sourceSection = interviewTaskSections.find(s =>
      s.questionName_array.some(q => q.question_ID === active.id)
    );
    dragSourceSectionId.current = sourceSection?.questionPaperSection_ID ?? null;

    // Collapse all sections ONLY if a SECTION is being dragged
    if (isSectionBeingDragged(active.id)) {
      setOpenSections(new Set());
    }
  };

  const handleDragOver = event => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const sourceSectionCurrent = interviewTaskSections.find(s =>
      s.questionName_array.some(q => q.question_ID === active.id)
    );
    const destSectionCurrent =
      interviewTaskSections.find(s => s.questionName_array.some(q => q.question_ID === over.id)) ||
      interviewTaskSections.find(s => s.questionPaperSection_ID === over.id);

    if (!sourceSectionCurrent || !destSectionCurrent) return;
    if (sourceSectionCurrent.questionPaperSection_ID === destSectionCurrent.questionPaperSection_ID) return;

    setOpenSections(prev => {
      const next = new Set(prev);
      next.add(destSectionCurrent.questionPaperSection_ID);
      return next;
    });

    setInterviewTaskSections(prevSections => {
      const updatedSections = prevSections.map(s => ({
        ...s,
        questionName_array: [...s.questionName_array]
      }));

      const sourceSection = updatedSections.find(s =>
        s.questionName_array.some(q => q.question_ID === active.id)
      );

      const destSectionByQuestion = updatedSections.find(s =>
        s.questionName_array.some(q => q.question_ID === over.id)
      );
      const destSectionById = updatedSections.find(s =>
        s.questionPaperSection_ID === over.id
      );
      const destinationSection = destSectionByQuestion || destSectionById;

      if (!sourceSection || !destinationSection) return prevSections;
      if (sourceSection.questionPaperSection_ID === destinationSection.questionPaperSection_ID) {
        return prevSections;
      }

      const sourceIndex = sourceSection.questionName_array.findIndex(q => q.question_ID === active.id);
      const destIndex = destSectionByQuestion
        ? destinationSection.questionName_array.findIndex(q => q.question_ID === over.id)
        : destinationSection.questionName_array.length;

      const [movedQuestion] = sourceSection.questionName_array.splice(sourceIndex, 1);
      destinationSection.questionName_array.splice(destIndex, 0, movedQuestion);

      return updatedSections;
    });
  };

  const moveQuestionWithinSection = (sections, sectionId, sourceIndex, destinationIndex) => {
    const updatedSections = [...sections];
    const section = updatedSections.find(s => s.questionPaperSection_ID === sectionId);

    if (!section) return sections;
    if (sourceIndex < 0) return sections;

    const safeDestinationIndex =
      destinationIndex < 0 ? section.questionName_array.length - 1 : destinationIndex;

    const [movedQuestion] = section.questionName_array.splice(sourceIndex, 1);
    section.questionName_array.splice(safeDestinationIndex, 0, movedQuestion);

    return updatedSections;
  };

  const moveQuestionAcrossSections = (
    sections,
    sourceSectionId,
    destinationSectionId,
    sourceIndex,
    destinationIndex
  ) => {
    const updatedSections = [...sections];

    const sourceSection = updatedSections.find(s => s.questionPaperSection_ID === sourceSectionId);
    const destinationSection = updatedSections.find(s => s.questionPaperSection_ID === destinationSectionId);

    if (!sourceSection || !destinationSection) return sections;
    if (sourceIndex < 0) return sections;

    const safeDestinationIndex =
      destinationIndex < 0 ? destinationSection.questionName_array.length : destinationIndex;

    // Remove question from source section
    const [movedQuestion] = sourceSection.questionName_array.splice(sourceIndex, 1);

    // Add question to destination section
    destinationSection.questionName_array.splice(safeDestinationIndex, 0, movedQuestion);

    return updatedSections;
  };

  const moveSection = (sections, activeId, overId) => {
    const sectionIndex = sections.findIndex(s => s.questionPaperSection_ID === activeId);
    const newSectionIndex = sections.findIndex(s => s.questionPaperSection_ID === overId);

    if (sectionIndex !== -1 && newSectionIndex !== -1) {
      return arrayMove(sections, sectionIndex, newSectionIndex);
    }

    return sections;
  };

  const handleDragEnd = event => {
    setDraggingItem(null);
    const { active, over } = event;
    if (!over) return;

    setInterviewTaskSections(prevSections => {
      let updatedSections = [...prevSections];

      // Check if the dragged item is a section
      const isSectionDrag = prevSections.some(s => s.questionPaperSection_ID === active.id);

      if (isSectionDrag) {
        if (active.id === over.id) return updatedSections;

        updatedSections = moveSection(updatedSections, active.id, over.id);

        // API call for section drag and drop
        dispatch({
          type: 'DRAG_SECTION',
          payload: {
            user_ID: loggedUser.userId,
            sections: updatedSections.map((section, index) => ({
              questionPaperSection_ID: section.questionPaperSection_ID.toString(),
              sectionOrder: (index + 1).toString()
            }))
          }
        });

        return updatedSections;
      }

      let sourceSection =
        updatedSections.find(s => s.questionPaperSection_ID === dragSourceSectionId.current) ||
        updatedSections.find(s => s.questionName_array.some(q => q.question_ID === active.id));

      const destinationSection =
        updatedSections.find(s => s.questionName_array.some(q => q.question_ID === over.id)) ||
        updatedSections.find(s => s.questionPaperSection_ID === over.id);

      if (!sourceSection || !destinationSection) return updatedSections;

      const isAcrossSection =
        sourceSection.questionPaperSection_ID !== destinationSection.questionPaperSection_ID;

      // After hover move, active.id can equal over.id. Still dispatch if section changed.
      if (active.id === over.id) {
        if (isAcrossSection) {
          dispatch({
            type: 'DRAG_QUESTION_ACROSS_SECTIONS',
            payload: {
              user_ID: loggedUser.userId,
              questionsPaperSections: [
                {
                  section_ID: sourceSection.questionPaperSection_ID,
                  questions: updatedSections
                    .find(s => s.questionPaperSection_ID === sourceSection.questionPaperSection_ID)
                    ?.questionName_array.map((q, index) => ({
                      question_ID: q.question_ID,
                      questionOrder: index + 1
                    }))
                },
                {
                  section_ID: destinationSection.questionPaperSection_ID,
                  questions: updatedSections
                    .find(s => s.questionPaperSection_ID === destinationSection.questionPaperSection_ID)
                    ?.questionName_array.map((q, index) => ({
                      question_ID: q.question_ID,
                      questionOrder: index + 1
                    }))
                }
              ]
            }
          });
        }

        return updatedSections;
      }

      let sourceIndex = sourceSection.questionName_array.findIndex(q => q.question_ID === active.id);
      if (sourceIndex < 0) {
        const fallbackSourceSection = updatedSections.find(s => s.questionName_array.some(q => q.question_ID === active.id));
        if (!fallbackSourceSection) return updatedSections;
        sourceSection = fallbackSourceSection;
        sourceIndex = sourceSection.questionName_array.findIndex(q => q.question_ID === active.id);
      }

      const destinationIndexByQuestion = destinationSection.questionName_array.findIndex(
        q => q.question_ID === over.id
      );
      const destinationIndex =
        destinationIndexByQuestion >= 0 ? destinationIndexByQuestion : destinationSection.questionName_array.length;

      if (!isAcrossSection) {
        updatedSections = moveQuestionWithinSection(
          updatedSections,
          sourceSection.questionPaperSection_ID,
          sourceIndex,
          destinationIndex
        );

        dispatch({
          type: 'DRAG_QUESTION',
          payload: {
            user_ID: loggedUser.userId,
            questions: updatedSections
              .find(s => s.questionPaperSection_ID === sourceSection.questionPaperSection_ID)
              ?.questionName_array.map((q, index) => ({
                question_ID: q.question_ID,
                questionOrder: index + 1
              }))
          }
        });
      } else {
        if (sourceIndex >= 0) {
          updatedSections = moveQuestionAcrossSections(
            updatedSections,
            sourceSection.questionPaperSection_ID,
            destinationSection.questionPaperSection_ID,
            sourceIndex,
            destinationIndex
          );
        }

        dispatch({
          type: 'DRAG_QUESTION_ACROSS_SECTIONS',
          payload: {
            user_ID: loggedUser.userId,
            questionsPaperSections: [
              {
                section_ID: sourceSection.questionPaperSection_ID,
                questions: updatedSections
                  .find(s => s.questionPaperSection_ID === sourceSection.questionPaperSection_ID)
                  ?.questionName_array.map((q, index) => ({
                    question_ID: q.question_ID,
                    questionOrder: index + 1
                  }))
              },
              {
                section_ID: destinationSection.questionPaperSection_ID,
                questions: updatedSections
                  .find(s => s.questionPaperSection_ID === destinationSection.questionPaperSection_ID)
                  ?.questionName_array.map((q, index) => ({
                    question_ID: q.question_ID,
                    questionOrder: index + 1
                  }))
              }
            ]
          }
        });
      }

      return updatedSections;
    });

    // Do not force-open all accordions after drag; they remain as user left them
  };

  const storeSection = (sectionIndex, _field, _value) => {
    setIsAddingNewSection(false);
    let tempInterviewTaskSections = interviewTaskSections;
    tempInterviewTaskSections[sectionIndex] = {
      ...tempInterviewTaskSections[sectionIndex],
      _field: _value,
      isNew: _field != 'sectionDescription'
    };

    setInterviewTaskSections(tempInterviewTaskSections);
    if (_field == 'sectionName') {
      if (_value == '') {
        setMessage(true);
      } else {
        setMessage(false);
      }
    }
    if (_field == 'sectionDescription') {
      if (_value == '') {
        setMessage(true);
      } else {
        setMessage(false);
      }
    }

    const section = interviewTaskSections[sectionIndex];
    const data = {
      user_ID: loggedUser.userId,
      projectsTask_ID: interviewTask.projectTask_ID,
      project_ID: projectId,
      projectScreener_ID: null,
      parentType: 'task',
      sectionName: section.sectionName,
      sectionDescription: section.sectionDescription,
      sectionOrder: sectionIndex + 1,
      fileType: null,
      timer: null
    };
    if (data.sectionName != '' || data.sectionDescription != '') {
      setIsSectionSaveLoading(true);
      setAddQuestionDisable(true);
      dispatch({ type: 'ADD_SECTION', payload: data });
    }
    const updatedStatus = [...sectionSavedStatus];
    updatedStatus[sectionIndex] = true; // Mark the section at index as saved
    setSectionSavedStatus(updatedStatus);
    setShowSaveButton(false);
  };

  const updateSection = (sectionIndex, _field, _value) => {
    if (_field == 'sectionName') {
      if (_value == '') {
        setMessage(true);
      } else {
        setMessage(false);
      }
    }
    if (_field == 'sectionDescription') {
      if (_value == '') {
        setMessage(true);
      } else {
        setMessage(false);
      }
    }
    let tempInterviewTaskSections = interviewTaskSections;
    tempInterviewTaskSections[sectionIndex] = { ...tempInterviewTaskSections[sectionIndex], _field: _value };

    setInterviewTaskSections(tempInterviewTaskSections);

    const section = tempInterviewTaskSections[sectionIndex];
    const data = {
      user_ID: loggedUser.userId,
      QuestionPaperSection_ID: section.questionPaperSection_ID,
      sectionName: _field == 'sectionName' ? _value : section.sectionName,
      sectionDescription:
        _field == 'sectionDescription' ? _value : section.sectionDescription,
      fileType: null,
      timer: null,
      shuffleQuestion: getSectionShuffleValue(section)
    };
    if (data.sectionName != '') {
      dispatch({ type: 'EDIT_SECTION', payload: data });
    }
    setShowSaveButton(true);
  };

  const createQuestion = sectionIndex => {
    setIsEditing(true);
    let tempInterviewTaskSections = interviewTaskSections.slice();

    !tempInterviewTaskSections[sectionIndex].hasOwnProperty('questionName_array') &&
      (tempInterviewTaskSections[sectionIndex] = {
        ...tempInterviewTaskSections[sectionIndex],
        questionName_array: []
      });

    let tempQuestionArray = tempInterviewTaskSections[sectionIndex].questionName_array;
    tempQuestionArray.push({
      question_ID: null,
      questionName: null,
      questionDescription: null,
      isRequired: switchvalue,
      isEdit: true,
      questionType_ID: 9,
      oldQuestionType_ID: 9,
      savedOption: null,
      buttonName: null,
      tags: [],
      ValueTypeChoices: [],
      choiceName_array: [],
      characterLimit: 500,
      maxFileSizeInMB: 10,
      numberOfFiles: 1
    });

    tempInterviewTaskSections[sectionIndex].questionName_array = tempQuestionArray;
    setNewQuestionIndex(sectionIndex);
    setEditQuestionId('');
    setAddQuestionDisable(true);
    setEditQuestionIndex(null);
    setDeleteQuestionIndex(null);
    setInterviewTaskSections(tempInterviewTaskSections);

    const sectionId = tempInterviewTaskSections[sectionIndex].questionPaperSection_ID;
    if (sectionId && !openSections.has(sectionId)) {
      toggleOpen(sectionId, true);
    }
  };
  const closeHandler = e => {
    setPopup(e);
  };

  const handleChangeQuestionType = (sectionIndex, questionIndex, questionTypeId, question) => {
    let tempInterviewTaskSections = interviewTaskSections.slice();

    question = {
      ...question,
      questionType_ID: questionTypeId,
      oldQuestionType_ID: question.oldQuestionType_ID,
      isEdit: true
    };

    tempInterviewTaskSections[sectionIndex].questionName_array[questionIndex] = question;
    setInterviewTaskSections(tempInterviewTaskSections);
  };

  const handleDuplicateQuestion = (sectionIndex, questionIndex, setCheckBoxRequired) => {
    let tempInterviewTaskSections = interviewTaskSections.slice();
    let question = tempInterviewTaskSections[sectionIndex]?.questionName_array[questionIndex];

    const duplicatedQuestion = {
      ...question,
      isEdit: true,
      question_ID: null,
      PrevQuestion_ID: question.question_ID,

      isLogicApplied: 0,
      isSkipLogicApplied: 0,
      ParentquestionAttached: null,
      selectedQuestion: null,
      selectedQuestionSectionAttached: null,
      selectedChoiceID: null,
      selectedLikerChocieID: null,
      LikertScaleID: null,
      skipSectionAttached: null,
      inputValue: null,
      comparibility_ID: null,
      selectedComparibilityID: null,
      ANDLogic: [],
      ORLogic: []
    };

    tempInterviewTaskSections[sectionIndex].questionName_array.splice(questionIndex + 1, 0, duplicatedQuestion);

    setInterviewTaskSections(tempInterviewTaskSections);
    setIsEditing(true);
    setCheckBoxRequired(duplicatedQuestion.isRequired);
  };

  const handleEditQuestion = (sectionIndex, questionIndex) => {
    let tempFormTaskSections = interviewTaskSections.slice();

    // Close any currently open question before opening the new one
    tempFormTaskSections = tempFormTaskSections.map((section, sIdx) => ({
      ...section,
      questionName_array: section.questionName_array.map((q, qIdx) => {
        if (q.isEdit && !(sIdx === sectionIndex && qIdx === questionIndex)) {
          return { ...q, isEdit: false };
        }
        return q;
      })
    }));

    let question = tempFormTaskSections[sectionIndex]?.questionName_array[questionIndex];
    question = { ...question, isEdit: true };

    tempFormTaskSections[sectionIndex].questionName_array[questionIndex] = question;
    setInterviewTaskSections(tempFormTaskSections);
    setIsEditing(true);
  };

  const renderSortableItemDragOverlay = id => {
    // Find the question and its section
    let foundSection = null;
    let foundQuestion = null;
    let foundSectionIndex = -1;
    let foundQuestionIndex = -1;

    interviewTaskSections.forEach((section, sIndex) => {
      const qIndex = section.questionName_array.findIndex(q => q.question_ID === id);
      if (qIndex !== -1) {
        foundSection = section;
        foundQuestion = section.questionName_array[qIndex];
        foundSectionIndex = sIndex;
        foundQuestionIndex = qIndex;
      }
    });

    if (!foundQuestion) return null;

    return (
      <div
        style={{
          background: 'white',
          transform: 'scale(1.02)',
          opacity: 1,
          transition: 'transform 0.2s ease',
          width: '100%',
          borderLeft: '3px solid #9EBE21',
          borderRadius: '10px'
        }}
      >
        <DesignQuestion
          key={foundQuestion.question_ID}
          sectionIndex={foundSectionIndex}
          setSwitchValue={setSwitchValue}
          switchvalue={switchvalue}
          questionIndex={foundQuestionIndex}
          sectionId={foundSection.questionPaperSection_ID}
          questionArrayLength={foundSection?.questionName_array?.length}
          question={foundQuestion}
          questionTypes={questionTypes}
          ValueTypeChoices={ValueTypeChoices}
          handleChangeQuestionType={handleChangeQuestionType}
          handleDuplicateQuestion={handleDuplicateQuestion}
          handleEditQuestion={handleEditQuestion}
          handleSetEditing={handleSetEditing}
          handleDeleteQuestion={handleDeleteQuestion}
          handleProjectTaskTab={handleProjectTaskTab}
          isInterview={task.taskType !== 'Form'}
          setEditQuestionIndex={setEditQuestionIndex}
          setNewQuestionIndex={setNewQuestionIndex}
          setDeleteQuestionIndex={setDeleteQuestionIndex}
          enableEdit={editQuestionId == foundQuestion?.question_ID}
          setEditQuestionId={setEditQuestionId}
          setAddQuestionDisable={setAddQuestionDisable}
          setQuestionIndex={setQuestionIndex}
          questionmessage={questionmessage}
          popupColor={popupColor}
          showCheckbox={true}
          setInterviewTaskSections={setInterviewTaskSections}
          interviewTaskSections={interviewTaskSections}
          task={task}
          isVirtualKeyboardEnabled={isVirtualKeyboardEnabled}
        />
      </div>
    );
  };

  const handleDeleteQuestion = (sectionIndex, questionIndex) => {
    let tempInterviewTaskSections = interviewTaskSections.slice();
    let question = tempInterviewTaskSections[sectionIndex]?.questionName_array[questionIndex];

    // Remove the question from the array
    tempInterviewTaskSections[sectionIndex].questionName_array.splice(questionIndex, 1);
    setInterviewTaskSections(tempInterviewTaskSections);
    setAddQuestionDisable(false);

    // Dispatch only if question_ID is not null
    if (question?.question_ID) {
      setQuestionIndex(questionIndex);
      setDeleteQuestionIndex(sectionIndex);
      setNewQuestionIndex(null);
      let payload = {
        user_ID: loggedUser.userId,
        questions_ID: question.question_ID
      };

      dispatch({
        type: 'REQUEST_DELETE_QUESITON',
        formData: payload
      });
    }
  };

  const handleDeleteSection = sectionIndex => {
    setDeleteSectionIndex(sectionIndex);

    let tempInterviewTaskSections = interviewTaskSections.slice();
    let section = tempInterviewTaskSections[sectionIndex];

    let payload = {
      user_ID: loggedUser.userId,
      projectTask_ID,
      QuestionPaperSection_ID: section.questionPaperSection_ID
    };

    tempInterviewTaskSections.splice(sectionIndex, 1);
    setInterviewTaskSections(tempInterviewTaskSections);
    dispatch({
      type: 'REQUEST_DELETE_SECTION',
      formData: payload
    });
    setAddSectionDisbale(false);
    setPopup(false);
  };
  const handleProjectTaskTab = () => {
    handleTaskTab(task.taskType, task.projectTask_ID, task.IsVisited);
  };

  const refreshTask = () => {
    maverickPortalhttp
      .makeRequest(
        `${maverickPortalApiEndPoint.getVideoTask.url}/${loggedUser.userId}/${projectId}/${projectTask_ID}`,
        maverickPortalApiEndPoint.getVideoTask.methodType
      )
      .then(response => {
        const sections = response.data.Response?.GetProjectTaskQuestions;
        setInterviewTaskSections(sections);
      });
  };

  const handleProjectTaskNext = () => {
    handleTaskTab(nextTask.taskType, nextTask.projectTask_ID, nextTask.IsVisited);
  };

  if (shouldShowInitialLoader) {
    return (
      <div className="d-flex justify-content-center py-5">
        <PageLoader size="100px" />
      </div>
    );
  }

  return (
    <>
      <section className="form-notification-section ">
        <div className="row py-2">
          <div className="col-md-12">
            <Heading color={'var(--deepBlue)'} fontSize="1.125rem" fontWeight="800">
              {interviewTask.taskName}
            </Heading>

            <div className="d-flex align-items-start gap-2 mt-1">
              <TextArea
                showCharacters={false}
                fontSize="0.75rem"
                fontWeight="500"
                placeholder="Add task description"
                value={interviewTask.taskDescription}
                onChange={e => {
                  const updatedTask = { ...interviewTask, taskDescription: e.target.value };
                  setInterviewTask(updatedTask);
                  onTaskDescriptionEdit(updatedTask, e.target.value);
                }}
                style={{ flex: 1 }}
              />
              {isTaskDescriptionEditing && (
                <CustomButton
                  variant="outlined"
                  buttonColor="var(--sapGreen)"
                  onClick={onSaveTaskDescription}
                  style={{ minWidth: 'auto', height: 'fit-content' }}
                >
                  <Icon>save</Icon>
                  Save
                </CustomButton>
              )}
            </div>
            <div className="d-flex justify-content-end mt-2">
              <div>
                <label className="switch ml-3 permission-toggle">
                  <input
                    type="checkbox"
                    name="virtualKeyboard"
                    checked={isVirtualKeyboardEnabled}
                    onChange={e => setIsVirtualKeyboardEnabled(e.target.checked)}
                  />
                  <span className="slider round"></span>
                </label>
                <span
                  className="font-weight-bold ml-2 mb-1"
                  style={{ color: 'var(--greyBlue)', position: 'relative', top: '-5px' }}
                >
                  Use Virtual Keyboard
                </span>
              </div>
            </div>
          </div>
        </div>

        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          autoScroll={true}
          onDragStart={handleDragStart}
          onDragOver={handleDragOver}
          onDragEnd={handleDragEnd}
          measuring={{
            droppable: {
              strategy: MeasuringStrategy.Always
            }
          }}
        >
          <SortableContext
            items={interviewTaskSections?.map(s => s.questionPaperSection_ID).filter(id => id !== null)}
          >
            {interviewTaskSections?.map((section, sIndex) => (
                <SortableSection
                  key={section.questionPaperSection_ID}
                  section={section}
                  isOpen={openSections.has(section.questionPaperSection_ID)}
                  toggleOpen={toggleOpen}
                  isDragging={draggingItem === section.questionPaperSection_ID}
                  sIndex={sIndex}
                />
            ))}
          </SortableContext>
          <DragOverlay dropAnimation={dropAnimation}>
            {draggingItem ? renderSortableItemDragOverlay(draggingItem) : null}
          </DragOverlay>
        </DndContext>

        <CustomDivider />
        <div>
          <CustomButton
            variant="outlined"
            buttonColor="var(--sapGreen)"
            className="mt-3"
            onClick={e => createSection()}
            disabled={addSectionDisable}
          >
            <Icon>add</Icon>
            Add New Section
          </CustomButton>
        </div>
        {isNewSection && sectionmessage && (
          <center>
            <div style={{ color: popupColor, fontWeight: 'bold', textAlign: 'left' }}>
              <div>{sectionmessage}</div>
            </div>
          </center>
        )}

        <div className="d-flex flex-column align-items-center justify-content-center mt-5">
          <Heading type="4">Well done!</Heading>
          <Heading type="5">Your progress so far has been saved</Heading>
          <div className="d-flex ">
            <Link to={`/project/${projectId}/invite-recruit`}>
              <Button size="mid" className="mt-4 mr-2" buttonColor="var(--sapGreen)">
                Recruit Respondents
              </Button>
            </Link>

            <Button size="mid" className="mt-4 ml-2" buttonColor="var(--sapGreen)" onClick={handleProjectTaskNext}>
              Design {nextTask.taskType != 'Video' ? nextTask.taskType : 'Interview'}
            </Button>
            <Link to={{ pathname: '/project/' + projectId + '/field' }} style={{ marginLeft: '15px' }}>
              <Button size="mid" className="mt-4 mr-2" buttonColor="var(--sapGreen)">
                Go To Field
              </Button>
            </Link>
          </div>
        </div>
        <ToastContainer hideProgressBar={true} />
      </section>
    </>
  );
}
